// Angular Import
import { Component } from '@angular/core';

@Component({
  selector: 'app-nav-left',
  templateUrl: './nav-left.component.html',
})
export class NavLeftComponent {}